export default {
  envConfigs: {
    SCHOOL_CODE: process.env.VUE_APP_SCHOOL_CODE,
    MAPED_STUDENT_IDENTITY: process.env.VUE_APP_MAPED_STUDENT_IDENTITY,
    MAPED_TEACHER_IDENTITY: process.env.VUE_APP_MAPED_TEACHER_IDENTITY,
    MAPED_VISITOR_IDENTITY: process.env.VUE_APP_MAPED_VISITOR_IDENTITY,
    MAPED_ADMIN_IDENTITY: process.env.VUE_APP_MAPED_ADMIN_IDENTITY,
    SYSTEM_CONFIG: process.env.VUE_APP_SYSTEM_CONFIG,
    PERSON_CENTER_API: process.env.VUE_APP_PERSON_CENTER_API,
    VUE_APP_CAS_URL: process.env.VUE_APP_CAS_URL,
    VUE_APP_URL: process.env.VUE_APP_URL,
    VUE_APP_SKIN_IMG_URL: process.env.VUE_APP_SKIN_IMG_URL,
    VUE_APP_COLOR_FILTER_DELTA: process.env.VUE_APP_COLOR_FILTER_DELTA,
    VUE_APP_SHOW_NEWS_DISPLAYMODE: process.env.VUE_APP_SHOW_NEWS_DISPLAYMODE,
    SHOW_PUBLIC_SERVE: process.env.VUE_APP_SHOW_PUBLIC_SERVE,
    VUE_APP_DIRECT_LOGIN: process.env.VUE_APP_DIRECT_LOGIN,
    IMG_BASE_URL: process.env.VUE_APP_IMG_BASE_URL,
    FIRST_DAY_OF_WEEK: process.env.VUE_APP_FIRST_DAY_OF_WEEK,
    EVENT_LIST_SETTING: process.env.VUE_APP_EVENT_LIST_SETTING,
    TO_DO_PROXY_ENTRY: process.env.VUE_APP_TO_DO_PROXY_ENTRY,
    NEN_VERSION_OF_SERVICE_DENTER: process.env.VUE_APP_NEN_VERSION_OF_SERVICE_DENTER,
    NEN_GET_RECOMMES_LIST: process.env.VUE_APP_NEN__GET_RECOMMES_LIST,
    HIDE_SCHEDULE_SEARCH: process.env.VUE_APP_HIDE_SCHEDULE_SEARCH,
    HIDE_PASSWORD_LOGIN: process.env.VUE_APP_HIDE_PASSWORD_LOGIN,
    HIDE_MOBILE_LOGIN: process.env.VUE_APP_HIDE_MOBILE_LOGIN,
    LOGIN_WAY: process.env.VUE_APP_LOGIN_WAY,
    AUTH_SETTING: process.env.VUE_APP_LOGIN_AUTH_SETTING,
    ADDRESSCARD_COST: process.env.VUE_APP_ADDRESSCARD_COST,
    ADMIN_PLATFORM: process.env.VUE_APP_PLATFORM,
    MESSAGE_API_URL: process.env.VUE_APP_MESSAGE_API, // 消息请求域名
    PORTAL_API: process.env.VUE_APP_PORTAL_API, // 门户接口地址
    PORTAL_API_TEST: process.env.VUE_APP_PORTAL_API_TEST, // 校内邮箱接口地址
    URLVIEW: process.env.VUE_APP_URLVIEW, // 校内邮箱查看地址，如果有校内邮箱--必配
    SCHOOLEMAIL: process.env.VUE_APP_SCHOOLEMAIL, // 是否显示校内邮箱，配置值为1，不显示校内邮箱；不配或者值为0，显示邮箱
    PLATFORM: process.env.VUE_APP_PLATFORM, // 云平台地址
    TTC_API: process.env.VUE_APP_TTC_API, //  事务域名
    ADMIN_CENTER_API: process.env.VUE_APP_ADMIN_CENTER_API, // 个人中心域名
    ADDRESS_BOOK_URL: process.env.VUE_APP_ADDRESS_BOOK_URL, // 通讯录接口地址
    FORMFLOW_API_URL: process.env.VUE_APP_FORMFLOW_API,
    FLOWINSTANCE_API_URL: process.env.VUE_APP_FLOWINSTANCE_API,
    SHOW_SERVICEAPP_SET_URL: process.env.VUE_APP_SHOW_SERVICEAPP_SET,
    APP_SPA_URL: process.env.VUE_APP_SPA_URL,
    FORMFLOW_DESIGN_API_URL: process.env.VUE_APP_FORMFLOW_DESIGN_API,
    SHOW_WEI_MEI: process.env.VUE_APP_SHOW_WEI_MEI,
    EXTERNAL_LINKS: process.env.VUE_APP_EXTERNAL_LINKS,
    SHOW_HOT_DATA_CARDS: process.env.VUE_APP_SHOW_HOT_DATA_CARDS,
    HISTORY_CHECK_URL: process.env.VUE_APP_HISTORY_CHECK_URL, //  事务中心-我的发起-历史归档查询
    SHOW_NEWS_DETAIL: process.env.VUE_APP_SHOW_NEWS_DETAIL, //  资讯列表、资讯中心是否显示资讯中心 1 显示，其他值不显示
    PERSONAL_CENTER_LINK: process.env.VUE_APP_PERSONAL_CENTER_LINK, //  资讯列表、资讯中心是否显示资讯中心 1 显示，其他值不显示
    CHANGE_THEME_NAV_ICON: process.env.VUE_APP_CHANGE_THEME_NAV_ICON, //  切换主题皮肤图标定制
    MYMESSAGE_AND_MESSAGECENTER: process.env.VUE_APP_MYMESSAGE_AND_MESSAGECENTER
  },
    businessManageNav: [{name:"岗位人员",code:"PostManagement",icon: "post-management",},
        {name:"应用服务",code:"ApplicationServiceManagement",icon: "application-service-management"},
        {name:"日历管理",code:"ScheduleManagement",icon: "calendar",},
        {name:"流程实例",code:"FlowInstance", icon: "flow-instance",},
        {name:"消息平台",code:"MessageServe",icon: "message-service",},
        {name:"资讯管理",code:"ContentRelease", icon: "file-copy"}
        ]
}
